import React, { useState } from 'react'
import Modal from 'react-modal';
import { toastr } from 'react-redux-toastr';
import {BsFillShareFill} from 'react-icons/bs'
import sign from 'jwt-encode'

function ModalShareCategories({formatMessage = () => {}, categoryId}) {
  const [show, setShow] = useState(false)


  const handleClose = () => {
    setShow(false)
  }

  const copy = () => {
    var copyText = document.getElementById("card_frame");
    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand("copy");
    toastr.success(formatMessage('titleFrameQuestionCopy'), formatMessage('msgFrameQuestionCopy'))
  }

  const id = sign({categoryId}, 'qbm31');

  return (
    <React.Fragment>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <i class="fas fa-code" style={{color: 'rgb(82, 196, 26)', marginRight: 5}} onClick={() => {setShow(true)}}></i>
        <a href={`https://${window.location.hostname}/question/view/${id}`} target='_blank'>
          <i class="fa fa-eye"></i>
        </a>
      </div>
      <Modal
          isOpen = {show}
          style = {{
              overlay : 999,
          }}
          onRequestClose={handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              <div className="create-dialog-modal-content__title">{formatMessage('frmTitleSharedfQuestionCategory')}</div>
              <div
                  onClick={handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <div className="create-dialog-form">
                <div className="row mb-5">
                  <textarea rows={4} id="card_frame" style={{width: '100%', border: '1px solid #d9d9d9'}}>
                    {`<iframe src="https://${window.location.hostname}/question/view/${id}" width="100%" height="670" frameborder="0"></iframe>`}
                  </textarea>
                </div>
                <div className="flex" style={{alignItems: 'center', justifyContent:'center'}}>
                  <button className="btn btn-primary" onClick={copy} >{formatMessage('btnModalCopyCategory')}</button>
                </div>
              </div>
          </div>
      </Modal>
    </React.Fragment>
    
  )
}

export default ModalShareCategories


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ModalShareCategories/ModalShareCategories.jsx